import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem, darken } from 'polished';
import { getProductDefaultInfo } from '../../../../utilities/selectors';
import {
  getZemplinProductDefaultInfo,
  getZemplinTrueCount,
  getElasticCategoryZemplinProductInfo,
} from '../../selectors';
import { OrderNrInput } from '../../Product/OrderNrInput';
import { TableRow } from '../../General/Table';
import {
  FlexCol,
  FlexRow,
  FlexRowCenterVertical,
} from '../../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../../Defaults/Text';
import { CountSetter } from '../../ProductDetail/CountSetter';
import { __ } from 'react-i18n';
import {
  getSymbolFromCurrency,
  formatPriceToString,
} from '../../../../utilities';
import { ModalMobileValue } from './ModalMobileValue';

export interface Props {
  product: any;
  theme: any;
  hasMinAmountInfo?: boolean;
  count: string;
  handleCountChange: any;
  isLoggedIn: any;
  isFromCategory?: boolean;
}

function ModalItemMobile({
  product,
  theme,
  hasMinAmountInfo,
  count,
  handleCountChange,
  isLoggedIn,
  isFromCategory,
}: Props) {
  const { currency } = getProductDefaultInfo(product);
  const {
    unit,
    price,
    priceWithoutVat,
    productPackages,
    unpackingCost,
  } = isFromCategory
    ? getElasticCategoryZemplinProductInfo(product)
    : getZemplinProductDefaultInfo(product);
  const step = unit === 'Mks' ? 0.001 : 1;
  const trueCount = unit === 'Mks' ? +count * 1000 : count;
  const correctUnpackingCost =
    productPackages > count && unpackingCost ? unpackingCost * +trueCount : 0;
  const correctPrice = isLoggedIn ? priceWithoutVat : price;
  const totalPriceText = isLoggedIn ? __('Spolu bez DPH') : __('Spolu s DPH');
  const totalPrice = correctPrice ? (correctPrice * +count).toFixed(2) : '';
  const priceWithUnpacking = (correctUnpackingCost + +totalPrice).toFixed(2);
  const minimalPrice = +priceWithUnpacking > 0.3 ? priceWithUnpacking : '0.3';

  return (
    <Wrapper>
      <PriceValuesWrapper>
        <ModalMobileValue
          title={__('Cena bez DPH')}
          value={`${correctPrice} ${getSymbolFromCurrency(currency)}`}
        />
        <ModalMobileValue
          title={__('Balenie')}
          value={`${productPackages} ${unit}`}
        />
        <CountWrapper>
          <CountSetter
            onChange={handleCountChange}
            unit={unit}
            count={count}
            step={step}
          />
        </CountWrapper>
        <ModalMobileValue
          title={totalPriceText}
          value={formatPriceToString(minimalPrice, currency)}
        />
      </PriceValuesWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  width: 100%;
  max-width: ${rem(320)};
  margin: 0 auto;
  padding: ${rem(24)} 0 0;

  ${({ theme }) => theme.mediab.s450`
      max-width: initial;
      width: 100%;
  `}
`;

const CountWrapper = styled.div`
  margin-top: ${rem(8)};
  margin-bottom: ${rem(24)};
`;

const PriceValuesWrapper = styled(FlexCol)`
  margin-bottom: ${rem(16)};
`;

const WithTheme: any = withTheme(ModalItemMobile);
export { WithTheme as ModalItemMobile };
